// The Expedition Pulse — LOCAL audio manifest (metadata only).
// The authoritative catalog is served by GET /api/audio/config. This file is a static,
// offline-safe fallback describing the system shape. It intentionally binds NO audio asset
// URLs (no remote URLs, no local track files) — the engine stays silent until approved
// placeholder assets are bound in a later phase.
export const MANIFEST_VERSION = "pulse-dev";

export const AUDIO_ASSETS = {}; // no tracks/stems bound yet (dormant phase)

// Minimal fallback catalog used only if the network config is unavailable while offline.
// Priorities/safety mirror the backend so the state machine still resolves transitions.
export const FALLBACK_CATALOG = {
  landing: { priority: 10, safety_immediate: false, transition_duration_ms: 1200 },
  dashboard: { priority: 15, safety_immediate: false, transition_duration_ms: 1200 },
  expedition_map: { priority: 20, safety_immediate: false, transition_duration_ms: 1200 },
  crew_selection: { priority: 25, safety_immediate: false, transition_duration_ms: 1200 },
  stake_review: { priority: 35, safety_immediate: false, transition_duration_ms: 1200 },
  expedition_exploration: { priority: 30, safety_immediate: false, transition_duration_ms: 1200 },
  strategic_decision: { priority: 40, safety_immediate: false, transition_duration_ms: 1200 },
  rising_danger: { priority: 60, safety_immediate: false, transition_duration_ms: 1200 },
  skill_challenge: { priority: 80, safety_immediate: true, transition_duration_ms: 250 },
  critical_danger: { priority: 100, safety_immediate: true, transition_duration_ms: 250 },
  narrow_escape: { priority: 85, safety_immediate: true, transition_duration_ms: 250 },
  failure: { priority: 90, safety_immediate: true, transition_duration_ms: 250 },
  success: { priority: 90, safety_immediate: true, transition_duration_ms: 250 },
  critical_success: { priority: 95, safety_immediate: true, transition_duration_ms: 250 },
  recovery_camp: { priority: 20, safety_immediate: false, transition_duration_ms: 1200 },
  rank_promotion: { priority: 70, safety_immediate: false, transition_duration_ms: 1200 },
  achievement_unlock: { priority: 65, safety_immediate: false, transition_duration_ms: 1200 },
  prestige_ceremony: { priority: 75, safety_immediate: false, transition_duration_ms: 1200 },
  rival_overtake: { priority: 55, safety_immediate: false, transition_duration_ms: 1200 },
  season_finale: { priority: 65, safety_immediate: false, transition_duration_ms: 1200 },
  hall_of_renown: { priority: 20, safety_immediate: false, transition_duration_ms: 1200 },
};

// Route → audio-state mapping. Purely descriptive; drives immersion/pacing only.
export function stateForRoute(pathname) {
  if (!pathname || pathname === "/") return "landing";
  if (pathname.startsWith("/dashboard")) return "dashboard";
  if (pathname.startsWith("/play")) return "crew_selection";
  if (pathname.startsWith("/daily")) return "expedition_map";
  if (pathname.startsWith("/mission")) return "expedition_exploration";
  if (pathname.startsWith("/camp")) return "recovery_camp";
  if (pathname.startsWith("/prestige")) return "prestige_ceremony";
  if (pathname.startsWith("/hall-of-renown")) return "hall_of_renown";
  if (pathname.startsWith("/rivals")) return "dashboard";
  if (pathname.startsWith("/leaderboards")) return "hall_of_renown";
  if (pathname.startsWith("/seasons") || pathname.startsWith("/my-seasons")) return "season_finale";
  if (pathname.startsWith("/history")) return "dashboard";
  if (pathname.startsWith("/achievements")) return "achievement_unlock";
  return "dashboard";
}
